import styled, { css } from 'styled-components';

import { $dmSansFontFamily, colorsPalettes, setFontVariant } from '@similarweb/styles';

export type EmptyStateVariant =
  | 'girl'
  | 'girl-in'
  | 'girl-calendar'
  | 'lens'
  | 'lens-small'
  | 'lens-rised'
  | 'cactus'
  | 'laboratory'
  | 'salesforce'
  | 'salesforceConnection'
  | 'girl-crm';

export const StyledEmptyStateContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
`;

export const StyledEmptyStateImage = styled.img<{ variant: EmptyStateVariant }>`
  ${({ variant }) => {
    switch (variant) {
      case 'lens':
        return css`
          margin: 163px 0 10px 5px;
          height: 218px;
        `;
      case 'lens-rised':
        return css`
          margin: 144px 0 10px 5px;
          height: 218px;
        `;
      case 'salesforce':
        return css`
          margin: 0;
          height: 114px;
        `;
      case 'salesforceConnection':
        return css`
          margin: 0;
          height: 140px;
        `;
      case 'laboratory':
        return css`
          margin: 24px 0 0 0;
          height: 110px;
        `;
      case 'lens-small':
        return css`
          margin: 72px 0 12px 3px;
          height: 162px;
          width: 171px;
        `;
      case 'girl':
        return css`
          margin: 107px 0 0 50px;
          height: 228px;
        `;
      case 'girl-in':
        return css`
          margin: 172px 0 7px 32px;
          height: 222px;
        `;
      case 'girl-calendar':
        return css`
          margin: 123px 0 0 34px;
          height: 228px;
        `;
      case 'cactus':
        return css`
          margin: 64px 0 10px;
          height: 220px;
        `;
      case 'girl-crm':
        return css`
          margin: 144px 0 7px 32px;
          height: 269px;
        `;
    }
  }}
`;

export const StyledEmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledEmptyStateButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const StyledEmptyStateTitle = styled.p`
  margin: 24px 0 0 0;
  ${setFontVariant('h6', colorsPalettes.carbon[400])};
  font-weight: 700;
  text-align: center;
`;

export const StyledEmptyStateDescription = styled.p`
  margin: 0;
  color: ${colorsPalettes.carbon[300]};
  font-family: ${$dmSansFontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
`;
